import React from "react";
import { Form, Button, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import UploadProgressRing from "../UploadProgressRing";

/**
 * Email file upload component
 */
const EmailFileUpload = ({ uploadInputRef, files, onFileChange, onDelete }) => {
  return (
    <Form.Field>
      <Button as="label" className="fileButton">
        <Icon name="plus" />
        Upload File
        <input
          ref={uploadInputRef}
          type="file"
          hidden
          multiple
          onChange={onFileChange}
        />
      </Button>
      <UploadProgressRing
        uploads={files}
        onDelete={onDelete}
        xOnComplete={true}
      />
    </Form.Field>
  );
};

EmailFileUpload.propTypes = {
  uploadInputRef: PropTypes.object.isRequired,
  files: PropTypes.array.isRequired,
  onFileChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default EmailFileUpload;
